var path = '/components/components/airport-payback-actions/component.tpl.html';
var html = "<div>\n    <button class=\"btn-delete\" ng-click=\"vm.cancelBooking();\" ng-if=\"!vm.hideActions\">\n        {{ 'general.buttons.cancel' | translate}}\n    </button>\n    <button class=\"btn-confirm\" ng-click=\"vm.confirmBooking();\" ng-if=\"!vm.hideActions\">\n        {{ 'general.buttons.confirm' | translate}}\n    </button>\n</div>\n<div style=\"margin-top: 10px;\">\n    <button ng-click=\"vm.editInformation()\"><span class=\"fal fa-pencil\"></span>&nbsp;{{'components.components.airport-payback-actions.quick_edit_information' | translate}}</button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/components/airport-payback-actions/component.tpl.html
// module id = 1956
// module chunks = 1